import React, { useEffect, useState } from 'react'
import ContainerDashboard from '../../components/layouts/ContainerDashboard'
import { useNavigate } from 'react-router-dom'
import StaffTable from './StaffTable'
import config, { axiosInstance } from '../Config'
import Loader from '../Loader'
import swal from 'sweetalert'
import { usePermissionData } from '../../AppContext'

const StaffIndex = () => {

    const [data, setData] = useState([])
    const [staff, setStaff] = useState([])
    const [page, setPage] = useState(1)
    const [loading, setLoading] = useState(false)

    const navigate = useNavigate()
    const { checkAccess } = usePermissionData()

    const [items_perpage, setItemsPerPage] = useState(10)

    useEffect(() => {
        window.scrollTo(0, 0)
        document.title = "Staff | Mindora"
        getStaffInfo()
    }, [])

    const getStaffInfo = async () => {
        setLoading(true)
        try {
            const res = await axiosInstance.get('staff')
            const list = res.data?.data ?? res.data ?? []
            setData(list)
            setStaff(list)
        } catch {
            swal('', 'Failed to load staff.', 'error')
        } finally {
            setLoading(false)
        }
    }

    const total_pages = Math.ceil(data?.length / items_perpage)
    const final_data = data?.slice(page * items_perpage - items_perpage, page * items_perpage)

    const changePage = (pagecount) => {
        if (pagecount > 0 && pagecount <= total_pages) {
            setPage(pagecount)
            window.scrollTo(0, 0)
        }
    }

    const onDelete = (userKey) => {
        swal({
            title: "Are you sure?",
            text: "You Want to Delete the Staff.",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (willDelete) => {
            if (willDelete) {
                setLoading(true)
                try {
                    await axiosInstance.delete(`staff/${userKey}`)
                    swal("", "Staff Deleted Successfully", "success")
                    const updated = data.filter(item => item.userKey !== userKey)
                    setData(updated)
                    setStaff(updated)
                } catch {
                    swal("", "Something Went Wrong!", "error")
                } finally {
                    setLoading(false)
                }
            }
        })
    }

    const filterByName = (e) => {
        if (page !== 1) setPage(1)
        const q = e.target.value.toLowerCase()
        setData(staff.filter(s =>
            s.name?.toLowerCase().includes(q) ||
            s.email?.toLowerCase().includes(q) ||
            s.phone?.toLowerCase().includes(q)
        ))
    }

    return (
        <>
            {loading && <Loader />}
            <ContainerDashboard title="Staff" description="Everything here">
                <section className="ps-dashboards" id="homepages">
                    <div className="row justify-content-between align-items-center">
                        <div className="col-md-12 ">
                            <div className="p-4 py-5 bg-gradientt rounded-4" style={{ minHeight: '75vh' }}>
                                <div className='d-md-flex justify-content-between align-items-start mb-4'>
                                    <div className="ps-section__search d-flex justify-content-end mb-4">
                                        <div className="ps-form--search-simple">
                                            <input
                                                className="form-control bg-white"
                                                type="text"
                                                onChange={filterByName}
                                                placeholder="Search Staff.."
                                            />
                                            <button type='button' style={{ right: '30px' }}>
                                                <i className="icon icon-magnifier"></i>
                                            </button>
                                        </div>
                                        <select className='form-select ms-3 fs-5'
                                            value={items_perpage}
                                            onChange={(e) => { if (page !== 1) setPage(1); setItemsPerPage(e.target.value) }}
                                            style={{ width: '110px', height: '45px', borderRadius: '8px' }}>
                                            <option value="5">Show 5</option>
                                            <option value="10">Show 10</option>
                                            <option value="20">Show 20</option>
                                            <option value="30">Show 30</option>
                                        </select>
                                    </div>
                                    <div className='text-center'>
                                        {checkAccess(6, 2) &&
                                            <button type="button"
                                                onClick={() => navigate(`${config.appUrl}add-staff`)}
                                                className="button btn-green color-white">
                                                <i className='icon-plus me-3 fs-5'></i>
                                                Add Staff
                                            </button>
                                        }
                                        <button type="button" onClick={() => navigate(-1)}
                                            className="button ms-3"
                                            style={{ background: '#1a1a2e', color: '#fff', borderRadius: '12px' }}>
                                            <i className='icon-arrow-left me-2'></i>
                                            Back
                                        </button>
                                    </div>
                                </div>

                                <StaffTable
                                    data={final_data}
                                    onDelete={onDelete}
                                    checkAccess={checkAccess}
                                />

                                <div className='d-flex flex-column align-items-end mt-5'>
                                    <p className='mb-4'>Show {final_data?.length} of {data?.length} items.</p>
                                    <div className='d-flex justify-content-md-start justify-content-center flex-wrap'>
                                        <div className={`bd-number-pagination rounded-2 me-3 mt-2`} onClick={() => changePage(page - 1)}>
                                            <i className='icon-arrow-left'></i>
                                        </div>
                                        {[...Array(total_pages)].map((_, i) => {
                                            const p = i + 1
                                            return (
                                                <div key={p}
                                                    className={`bd-number-pagination rounded-2 mx-1 pe-1 mt-2 ${page === p && 'activepage'}`}
                                                    onClick={() => changePage(p)}>
                                                    {p < 10 ? ('0' + p) : p}
                                                </div>
                                            )
                                        })}
                                        <div className={`bd-number-pagination rounded-2 ms-3 mt-2`} onClick={() => changePage(page + 1)}>
                                            <i className='icon-arrow-right'></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </ContainerDashboard>
        </>
    )
}

export default StaffIndex
